<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
</script>

<script lang="ts">
	import { onMount } from 'svelte';
	import type { ImageSelectorConfig } from '$lib/config';
	import { FormController } from '../actions';
	import { activeElement } from '$lib/client/store';

	export const InstanceID = count;
	count += 1;
	//export let Valid = false;
	export let Config: ImageSelectorConfig;
	//export let endingTabIndex = startingTabIndex + Config.Choices.length - 1;
	let Required = Config.Required;
	let MinSelections = Required ? 1 : 0;
	let MaxSelections = 1;
	let Title = Config.Title;
	export let Values: string[] = [];
	export let showInvalidFeedback = false;

	$: curEntries = Values.length;

	// if (Required) {
	// 	let newVals = [];
	// 	for (let i = 0; i < MinSelections; i++) {
	// 		newVals.push('');
	// 	}
	// 	Values = Values.concat(newVals);
	// }
	onMount(() => {
		if (!Required && MinSelections > 0) {
			alert(Title + ' has an error: MinEntries must be 0 if Required is false');
		}
		// for (let i = 0; i < MaxEntries; i++) {
		// 	if (OutlineEl[i] == undefined) {
		// 		return;
		// 	}
		// 	//@ts-expect-error
		// 	new mdb.Input(OutlineEl[i]).init();
		// }
	});

	// /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/

	function updateSelections(target: HTMLElement) {
		//the target is either img or label depending on whether or not they clicked the image or the label
		//How do I make any click result in the target being the label?
		// If the target is an image, get the parent label
		let checkboxEl;
		if (target.tagName === 'IMG') {
			checkboxEl = target.parentElement as HTMLDivElement;
		} else {
			checkboxEl = target as HTMLDivElement;
		}
		console.log(checkboxEl);
		if (!checkboxEl) return;
		if (checkboxEl.dataset.choice_index === undefined) return;
		let choice_index = checkboxEl.dataset.choice_index;
		Values = [choice_index];
		// let value = label.id;
		// let index = Values.indexOf(value);
		// console.log(value, index, label);
		// if (index == -1) {
		// 	//Values.push(value);
		// 	Values = [value];
		// 	label.classList.add('image-checkbox-checked');
		// } else {
		// 	Values.splice(index, 1);
		// 	label.classList.remove('image-checkbox-checked');
		// }
		let checkboxes = checkboxEl.parentElement?.parentElement?.querySelectorAll(
			'.image-checkbox'
		) as NodeListOf<HTMLDivElement>;
		if (!checkboxes) return;
		for (let checkbox of checkboxes) {
			if (checkbox.dataset.choice_index === undefined) continue;
			if (
				Values.includes(checkbox.dataset.choice_index) &&
				!checkbox.classList.contains('image-checkbox-checked')
			) {
				checkbox.classList.add('image-checkbox-checked');
				checkbox.ariaChecked = 'true';
			} else if (checkbox.classList.contains('image-checkbox-checked')) {
				checkbox.classList.remove('image-checkbox-checked');
				checkbox.ariaChecked = 'false';
			}
		}
		let OnSelect = Config.Choices[parseInt(choice_index)].OnSelect;
		if (OnSelect !== undefined) {
			FormController.do_actions(OnSelect);
		}
		setValid();
	}

	function handleClick(e: MouseEvent) {
		if (e.target instanceof HTMLElement) {
			updateSelections(e.target);
		}
	}

	function handleKeydown(e: KeyboardEvent) {
		if (!(e.target instanceof HTMLElement)) {
			return;
		}
		// Check if the key pressed is 'Enter'
		if (e.key === 'Enter') {
			updateSelections(e.target);
		}
	}

	export function setInvalid() {
		showInvalidFeedback = true;
	}

	export function setValid() {
		showInvalidFeedback = false;
	}

	export function appendData(formData: FormData) {
		// let combinedStr = '';
		// for (let i = 0; i < curEntries; i++) {
		// 	combinedStr += inputComps[i].Value + '|';
		// }
		// //remove last '|'
		// combinedStr = combinedStr.slice(0, -1);
		if (Config.DBCol) {
			formData.append(Config.DBCol, Values[0]);
		} else {
			console.error('ImageSelector requires a DBCol');
		}
	}

	export function setNuetral() {
		showInvalidFeedback = false;
	}

	export async function validate() {
		let valid = Values.length == 1;
		if (!valid && !Config.Required) {
			valid = true;
			setNuetral();
		} else if (!valid) {
			setInvalid();
		} else {
			setValid();
		}
		// let valid = true;
		// for (let i = 0; i < curEntries; i++) {
		// 	let iValid = inputComps[i].validate();
		// 	if (iValid == false) {
		// 		valid = false;
		// 	}
		// }
		// Valid = valid;
		return valid;
	}
	export function focus() {
		Config.Choices[0].el.focus();
	}
</script>

<div
	class="form-group row g-2 justify-content-center required"
	id="ImageSelector"
	class:red-outline={showInvalidFeedback}
>
	{#if Title}<div class="comp-title">{Title} (Select One)</div>
	{/if}
	<div class="invalid-tooltip2" class:hidden={!showInvalidFeedback}>Please select an option</div>
	{#each Config.Choices as choice, index}
		<div class="p-1 col-xs col-6 col-sm4 pImage text-center">
			<div
				class="image-checkbox"
				on:click={handleClick}
				on:keydown={handleKeydown}
				data-choice_index={index}
				aria-label={choice.Description}
				role="checkbox"
				aria-checked="false"
				tabindex={0}
				bind:this={choice.el}
				class:image-checkbox-active={$activeElement == choice.el}
			>
				<img
					class="img-fluid-p-1 img-responsive imageSelectorFunction"
					src={choice.ImageURL}
					alt={choice.Description}
					data-choice_index={index}
				/><i class="fa fa-check hidden" />{choice.Description}
			</div>
		</div>
	{/each}
</div>

<style>
	.image-checkbox-active:not(.image-checkbox-checked) {
		border-color: #888888;
	}
	.invalid-tooltip2 {
		top: 100%;
		z-index: 5;
		max-width: 100%;
		padding: 6px 16px;
		margin-top: 0.1rem;
		background-color: rgba(220, 76, 100, 0.9);
		border-radius: 0.25rem !important;
		color: #fff;
	}
	.red-outline {
		outline: 1px solid red;
		outline-offset: -15px;
	}
</style>
